// src/components/menu/MenuToggleButton.jsx
import React, { Component } from 'react';

export default class MenuToggleButton extends Component {
  render() {
    const { open, onToggle, className = '' } = this.props;
    return (
      <button
        type="button"
        className={`menu-toggle-btn ${className}`}
        aria-label={open ? 'Close menu' : 'Open menu'}
        aria-expanded={open ? 'true' : 'false'}
        aria-controls="app-sidebar"
        onClick={onToggle}
      >
        <span aria-hidden="true">{open ? '✕' : '☰'}</span>
      </button>
    );
  }
}
